import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CentralComponent } from './central.component';
import { TaskComponent } from './components/task/containers/task.component';
import { IframeBaseComponent } from '../iframeContainer/iframeBaseComponent/iframe-base.component';
import { TaskDetailComponent } from './components/task/components/task-detail/task-detail.component';
import { NewTaskComponent } from './components/task/components/task-new/task-new.component';
import { OpenTaskComponent } from './components/task/components/task-open/task-open.component';
import { ClosedTaskComponent } from './components/task/components/task-close/task-closed.component';
import { ManageHelpComponent } from './components/manage-help-component/manage-help-component.component';

const routes: Routes = [
  { path: '', redirectTo: 'central', pathMatch: 'full' },

  {
    path: 'central',
    component: CentralComponent,
  },
  {
    path: 'central/task/new',
    component: NewTaskComponent,
  },
  {
    path: 'central/task/open',
    component: OpenTaskComponent,
  },
  {
    path: 'central/tasks/closed',
    component: ClosedTaskComponent,
  },
  {
    path: 'central/task/detail/:id',
    component: TaskDetailComponent,
  },
  {
    path: 'central/tasks/',
    component: TaskComponent,
  },
  {
    path: 'central/task-search-order/:orderNumber/:orderType',
    component: TaskComponent,
  },
  {
    path: 'central/task-search-customer/:customerNumber/:customerName',
    component: TaskComponent,
  },
  {
    path: 'central/help-how-to/:id',
    component: IframeBaseComponent,
  },

  {
    path: 'central/manage/how-to-help-component',
    component: ManageHelpComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CentralRoutingModule {}
